import { Directive, computed, input } from '@angular/core';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';

@Directive({
  selector: 'brn-radio[hlm],[hlmRadio]',
  standalone: true,
  host: {
    '[class]': '_computedClass()',
  },
})
export class HlmRadioDirective {
  public readonly userClass = input<ClassValue>('');
  protected _computedClass = computed(() =>
    hlm('flex items-center radioField cursor-pointer', this.userClass()),
  );
}
